export default "__VITE_ASSET__CY4OOt15__"